import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import cancel from "../assets/images/navbar/cancel.png";
import arrow from "../assets/images/order/orange-arrow.png";

type SigninModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onGetStarted?: () => void;
  mobileNumber: string;
  setMobileNumber: (number: string) => void;
};

const SigninModal: React.FC<SigninModalProps> = ({ isOpen, onClose, onGetStarted, mobileNumber, setMobileNumber }) => {
  
  if (!isOpen) return null;

  const handleGetStarted = () => {
    if (mobileNumber.length === 10 && onGetStarted) {
      onGetStarted();
    } else {
      alert("Please enter a valid 10-digit mobile number");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && mobileNumber.length === 10) {
      handleGetStarted();
    }
  };

  return (
    <>
      {/* Backdrop Overlay - Prevent closing during registration */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1003]"
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1004] pointer-events-none">
        <div
          className="w-full h-full md:w-[545px] md:h-auto p-6 md:p-8 rounded-none md:rounded-[24px] bg-white dark:bg-gray-800 pointer-events-auto relative transition-colors"
          style={{
            boxShadow: "-23px 23px 72px 0 rgba(0, 0, 0, 0.15)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Logo */}
          <div className="mb-6 md:mb-[36px] mt-4 md:mt-0">
            <img src={logo} alt="Duddus" className="h-[54px] w-[166px]" />
          </div>

          {/* Title */}
          <h2 className="text-[#050505] dark:text-gray-200 font-Urbanist text-2xl md:text-[32px] font-semibold leading-[125%] mb-2 md:mb-[8px]">
            Sign Up/Sign In
          </h2>

          {/* Subtitle */}
          <p className="text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-sm md:text-[16px] font-medium leading-[140%] mb-6 md:mb-[24px]">
            Enter your mobile number to get started
          </p>

          {/* Mobile Number Input */}
          <div className="flex items-center gap-2 border border-[#E0E0E0] dark:border-gray-600 rounded-[12px] px-4 py-3 mb-8 md:mb-[100px] bg-white dark:bg-gray-700 transition-colors">
            <span className="text-[#050505] dark:text-gray-200 font-Urbanist text-[16px] font-medium">
              +91
            </span>
            <div className="h-[24px] w-[1px] bg-[#E0E0E0] dark:bg-gray-600"></div>
            <input
              type="tel"
              placeholder="Enter your mobile number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
              onKeyPress={handleKeyPress}
              className="flex-1 outline-none text-[#050505] dark:text-gray-200 bg-transparent font-Urbanist text-[16px] placeholder:text-[#BDBDBD] dark:placeholder:text-gray-500"
              maxLength={10}
              autoFocus
            />
          </div>

          {/* Get Started Button */}
          <button
            onClick={handleGetStarted}
            className="w-full flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#E67A00] transition-colors"
          >
            <span className="text-white font-Urbanist text-[20px] font-semibold leading-[140%]">
              Get Started
            </span>
            <div className="h-[42px] w-[42px] flex justify-center items-center bg-white rounded-full">
              <img
                src={arrow}
                alt="right arrow"
                className="h-[41px] w-[30px] stroke-[2.587px] stroke-[#FB8606]"
              />
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default SigninModal;
